export default __webpack_public_path__ + "2d331b3.svg";